import React from "react"
import { graphql } from "gatsby"
import { Layout, Section, ProjectCard } from "../components/Site"

export default ({ data }) => {
  const nodes = data.allMarkdownRemark.nodes
  const packages = nodes.filter(node => node.frontmatter.tags.includes("Package"))
  const projects = nodes.filter(node => !node.frontmatter.tags.includes("Package"))

  return (
    <Layout title="Projects">
      <h1 className="page-title">Projects</h1>
      <p className="page-lead">Open-source packages and side projects, mostly around R and Shiny.</p>

      <Section id="packages" n="01" title="Packages">
        <div className="grid">
          {packages.map(node => (
            <ProjectCard key={node.id} node={node} feature />
          ))}
        </div>
      </Section>

      <Section id="showcases" n="02" title="Apps and showcases">
        <div className="grid">
          {projects.map(node => (
            <ProjectCard key={node.id} node={node} />
          ))}
        </div>
      </Section>
    </Layout>
  )
}

export const query = graphql`
  query {
    allMarkdownRemark(
      filter: { fileAbsolutePath: { regex: "/content/blog/" } }
      sort: { fields: [frontmatter___date], order: DESC }
    ) {
      nodes {
        id
        excerpt(pruneLength: 160)
        frontmatter {
          title
          tags
          link
          repo
        }
      }
    }
  }
`
